import EventsModel from '../Apis/Events'
import Controller from './Controller'

export default class EventsController extends Controller {
  constructor() {
    super(new EventsModel())
  }
}
